// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"65":"564b6c3b","70":"500209f0","93":"410d5ea2","161":"4b9a6642","285":"f3d0cc5e","568":"ba2618d2","908":"0e6a1a43","934":"cf24a4fe"}[chunkId] + ".css";
};